"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SignalingProtocol_js_1 = require("../signalingprotocol/SignalingProtocol.js");

var DefaultVideoStreamIdSet_1 = require("../videostreamidset/DefaultVideoStreamIdSet");

var VideoStreamDescription_1 = require("./VideoStreamDescription");
/**
 * [[DefaultVideoStreamIndex]] implements [[VideoStreamIndex]] to facilitate video stream subscription
 * and includes query functions for stream id and attendee id.
 */


var DefaultVideoStreamIndex = /*#__PURE__*/function () {
  function DefaultVideoStreamIndex(logger) {
    _classCallCheck(this, DefaultVideoStreamIndex);

    this.logger = logger;
    this.currentIndex = null;
    this.indexForSubscribe = null;
    this.currentSubscribeAck = null; // These are based on the index at the time of the last Subscribe Ack

    this.subscribeTrackToStreamMap = null;
    this.subscribeStreamToAttendeeMap = null;
    this.subscribeStreamToExternalUserIdMap = null;
    this.subscribeSsrcToStreamMap = null; // These are based on the most up to date index

    this.streamToAttendeeMap = null;
    this.streamToExternalUserIdMap = null;
    this.videoStreamDescription = new VideoStreamDescription_1.default();
    this.videoStreamDescription.trackLabel = 'AmazonChimeExpressVideo';
    this.videoStreamDescription.streamId = 2;
    this.videoStreamDescription.groupId = 2;
  }

  _createClass(DefaultVideoStreamIndex, [{
    key: "localStreamDescriptions",
    value: function localStreamDescriptions() {
      // localStreamDescriptions are used to construct IndexFrame
      // old behavior for single video is to have streamId and groupId trackLabel fixed as the follows
      return [this.videoStreamDescription.clone()];
    }
  }, {
    key: "convertBpsToKbps",
    value: function convertBpsToKbps(avgBitrateBps) {
      if (avgBitrateBps > 0 && avgBitrateBps < 1000) {
        return 1;
      } else {
        return Math.trunc(avgBitrateBps / 1000);
      }
    }
  }, {
    key: "remoteStreamDescriptions",
    value: function remoteStreamDescriptions() {
      var _this = this;

      if (!this.currentIndex || !this.currentIndex.sources) {
        return [];
      }

      var streamInfos = [];
      this.currentIndex.sources.forEach(function (source) {
        var description = new VideoStreamDescription_1.default();
        description.attendeeId = source.attendeeId;
        description.groupId = source.groupId;
        description.streamId = source.streamId;
        description.maxBitrateKbps = source.maxBitrateKbps;
        description.avgBitrateKbps = _this.convertBpsToKbps(source.avgBitrateBps);
        streamInfos.push(description);
      });
      return streamInfos;
    }
  }, {
    key: "integrateUplinkPolicyDecision",
    value: function integrateUplinkPolicyDecision(param) {
      if (!!param && param.length) {
        var encodingParam = param[0];
        this.videoStreamDescription.maxBitrateKbps = encodingParam.maxBitrate / 1000;
        this.videoStreamDescription.maxFrameRate = encodingParam.maxFramerate;
      }
    }
  }, {
    key: "integrateIndexFrame",
    value: function integrateIndexFrame(indexFrame) {
      this.currentIndex = indexFrame; // In the Amazon Chime SDKs, we assume a one to one mapping of group ID to profile ID when creating
      // video tiles (multiple video sources are supported through applying a `Modality` to a given profile/session token)
      //
      // We enforce this here to mitigate any possible duplicate group IDs left from a reconnection where the previous
      // signal channel hasn't been timed out yet.  To guarantee we receive the latest stream we use the highest group ID
      // since they are monotonically increasing.

      var attendeeIdToMainGroupIdMap = new Map(); // Improve performance by not filtering sources unless
      // we know the list will actually change

      var attendeeWithMultipleGroupIdsExists = false;

      var _iterator = _createForOfIteratorHelper(indexFrame.sources),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var source = _step.value;

          if (!attendeeIdToMainGroupIdMap.has(source.attendeeId)) {
            // We haven't see this attendee ID so just keep track of it
            attendeeIdToMainGroupIdMap.set(source.attendeeId, source.groupId);
            continue;
          } // Otherwise see if we should use the group ID corresponding to this source (we prefer the highest for each attendee)


          var currentGroupId = attendeeIdToMainGroupIdMap.get(source.attendeeId);

          if (currentGroupId < source.groupId) {
            this.logger.warn("Old group ID ".concat(currentGroupId, " found for attendee ID ").concat(source.attendeeId, ", replacing with newer group ID ").concat(source.groupId));
            attendeeIdToMainGroupIdMap.set(source.attendeeId, source.groupId);
          }

          attendeeWithMultipleGroupIdsExists = true;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (attendeeWithMultipleGroupIdsExists) {
        // Only use the sources corresponding to the main group IDs for the given attendee ID
        this.currentIndex.sources = this.currentIndex.sources.filter(function (source) {
          return attendeeIdToMainGroupIdMap.get(source.attendeeId) === source.groupId;
        });
      }

      this.streamToAttendeeMap = null;
      this.streamToExternalUserIdMap = null;
    }
  }, {
    key: "subscribeFrameSent",
    value: function subscribeFrameSent() {
      // This is called just as a Subscribe is being sent.  Save corresponding Index
      this.indexForSubscribe = this.currentIndex;
    }
  }, {
    key: "integrateSubscribeAckFrame",
    value: function integrateSubscribeAckFrame(subscribeAck) {
      this.currentSubscribeAck = subscribeAck; // These are valid until the next Subscribe Ack even if the index is updated

      this.subscribeTrackToStreamMap = this.buildTrackToStreamMap(this.currentSubscribeAck);
      this.subscribeSsrcToStreamMap = this.buildSSRCToStreamMap(this.currentSubscribeAck);
      this.subscribeStreamToAttendeeMap = this.buildStreamToAttendeeMap(this.indexForSubscribe);
      this.subscribeStreamToExternalUserIdMap = this.buildStreamExternalUserIdMap(this.indexForSubscribe);
    }
  }, {
    key: "integrateBitratesFrame",
    value: function integrateBitratesFrame(bitrates) {
      var _this2 = this;

      if (this.currentIndex) {
        var _iterator2 = _createForOfIteratorHelper(bitrates.bitrates),
            _step2;

        try {
          var _loop = function _loop() {
            var bitrate = _step2.value;

            var source = _this2.currentIndex.sources.find(function (source) {
              return source.streamId === bitrate.sourceStreamId;
            });

            if (source !== undefined) {
              source.avgBitrateBps = bitrate.avgBitrateBps;
            }
          };

          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "allStreams",
    value: function allStreams() {
      var set = new DefaultVideoStreamIdSet_1.default();

      if (this.currentIndex) {
        var _iterator3 = _createForOfIteratorHelper(this.currentIndex.sources),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var source = _step3.value;
            set.add(source.streamId);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      return set;
    }
  }, {
    key: "allVideoSendingSourcesExcludingSelf",
    value: function allVideoSendingSourcesExcludingSelf(selfAttendeeId) {
      var videoSources = [];
      var attendeeSet = new Set();

      if (this.currentIndex) {
        if (this.currentIndex.sources && this.currentIndex.sources.length) {
          var _iterator4 = _createForOfIteratorHelper(this.currentIndex.sources),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var stream = _step4.value;
              var attendeeId = stream.attendeeId,
                  externalUserId = stream.externalUserId,
                  mediaType = stream.mediaType;

              if (attendeeId !== selfAttendeeId && mediaType === SignalingProtocol_js_1.SdkStreamMediaType.VIDEO) {
                if (!attendeeSet.has(attendeeId)) {
                  videoSources.push({
                    attendee: {
                      attendeeId: attendeeId,
                      externalUserId: externalUserId
                    }
                  });
                  attendeeSet.add(attendeeId);
                }
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      }

      return videoSources;
    }
  }, {
    key: "streamSelectionUnderBandwidthConstraint",
    value: function streamSelectionUnderBandwidthConstraint(selfAttendeeId, largeTileAttendeeIds, smallTileAttendeeIds, bandwidthKbps) {
      var newAttendees = new Set();

      if (this.currentIndex) {
        var _iterator5 = _createForOfIteratorHelper(this.currentIndex.sources),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var stream = _step5.value;

            if (stream.attendeeId === selfAttendeeId || stream.mediaType !== SignalingProtocol_js_1.SdkStreamMediaType.VIDEO) {
              continue;
            }

            if (!largeTileAttendeeIds.has(stream.attendeeId) && !smallTileAttendeeIds.has(stream.attendeeId)) {
              newAttendees.add(stream.attendeeId);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      var attendeeToStreamDescriptorMap = this.buildAttendeeToSortedStreamDescriptorMapExcludingSelf(selfAttendeeId);
      var selectionMap = new Map();
      var usage = 0;
      attendeeToStreamDescriptorMap.forEach(function (streams, attendeeId) {
        selectionMap.set(attendeeId, streams[0]);
        usage += streams[0].maxBitrateKbps;
      });
      usage = this.trySelectHighBitrateForAttendees(attendeeToStreamDescriptorMap, largeTileAttendeeIds, usage, bandwidthKbps, selectionMap);
      this.trySelectHighBitrateForAttendees(attendeeToStreamDescriptorMap, newAttendees, usage, bandwidthKbps, selectionMap);
      var streamSelectionSet = new DefaultVideoStreamIdSet_1.default();

      var _iterator6 = _createForOfIteratorHelper(selectionMap.values()),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var source = _step6.value;
          streamSelectionSet.add(source.streamId);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return streamSelectionSet;
    }
  }, {
    key: "highestQualityStreamFromEachGroupExcludingSelf",
    value: function highestQualityStreamFromEachGroupExcludingSelf(selfAttendeeId) {
      var set = new DefaultVideoStreamIdSet_1.default();

      if (this.currentIndex) {
        var maxes = new Map();

        var _iterator7 = _createForOfIteratorHelper(this.currentIndex.sources),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var source = _step7.value;

            if (source.attendeeId === selfAttendeeId || source.mediaType !== SignalingProtocol_js_1.SdkStreamMediaType.VIDEO) {
              continue;
            }

            if (!maxes.has(source.groupId) || source.maxBitrateKbps > maxes.get(source.groupId).maxBitrateKbps) {
              maxes.set(source.groupId, source);
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        var _iterator8 = _createForOfIteratorHelper(maxes.values()),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _source = _step8.value;
            set.add(_source.streamId);
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }

      return set;
    }
  }, {
    key: "numberOfVideoPublishingParticipantsExcludingSelf",
    value: function numberOfVideoPublishingParticipantsExcludingSelf(selfAttendeeId) {
      return this.highestQualityStreamFromEachGroupExcludingSelf(selfAttendeeId).array().length;
    }
  }, {
    key: "numberOfParticipants",
    value: function numberOfParticipants() {
      if (!!this.currentIndex.numParticipants) {
        return this.currentIndex.numParticipants;
      }

      return -1;
    }
  }, {
    key: "attendeeIdForTrack",
    value: function attendeeIdForTrack(trackId) {
      var streamId = this.streamIdForTrack(trackId);

      if (streamId === undefined || !this.subscribeStreamToAttendeeMap) {
        this.logger.warn("no attendee found for track ".concat(trackId));
        return '';
      }

      var attendeeId = this.subscribeStreamToAttendeeMap.get(streamId);

      if (!attendeeId) {
        this.logger.info("track ".concat(trackId, " (stream ").concat(streamId, ") does not correspond to a known attendee"));
        return '';
      }

      return attendeeId;
    }
  }, {
    key: "externalUserIdForTrack",
    value: function externalUserIdForTrack(trackId) {
      var streamId = this.streamIdForTrack(trackId);

      if (streamId === undefined || !this.subscribeStreamToExternalUserIdMap) {
        this.logger.warn("no external user id found for track ".concat(trackId));
        return '';
      }

      var externalUserId = this.subscribeStreamToExternalUserIdMap.get(streamId);

      if (!externalUserId) {
        this.logger.info("track ".concat(trackId, " (stream ").concat(streamId, ") does not correspond to a known externalUserId"));
        return '';
      }

      return externalUserId;
    }
  }, {
    key: "attendeeIdForStreamId",
    value: function attendeeIdForStreamId(streamId) {
      if (!this.streamToAttendeeMap) {
        if (this.currentIndex) {
          this.streamToAttendeeMap = this.buildStreamToAttendeeMap(this.currentIndex);
        } else {
          return '';
        }
      }

      var attendeeId = this.streamToAttendeeMap.get(streamId);

      if (!attendeeId) {
        this.logger.info("stream ".concat(streamId, ") does not correspond to a known attendee"));
        return '';
      }

      return attendeeId;
    }
  }, {
    key: "groupIdForStreamId",
    value: function groupIdForStreamId(streamId) {
      var _iterator9 = _createForOfIteratorHelper(this.currentIndex.sources),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _source2 = _step9.value;

          if (_source2.streamId === streamId) {
            return _source2.groupId;
          }
        } // If wasn't found in current index, then it could be in index used in last subscribe

      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      if (!!this.indexForSubscribe) {
        var _iterator10 = _createForOfIteratorHelper(this.indexForSubscribe.sources),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var source = _step10.value;

            if (source.streamId === streamId) {
              return source.groupId;
            }
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }

      return undefined;
    }
  }, {
    key: "StreamIdsInSameGroup",
    value: function StreamIdsInSameGroup(streamId1, streamId2) {
      if (this.groupIdForStreamId(streamId1) === this.groupIdForStreamId(streamId2)) {
        return true;
      }

      return false;
    }
  }, {
    key: "streamIdForTrack",
    value: function streamIdForTrack(trackId) {
      if (!this.subscribeTrackToStreamMap) {
        return undefined;
      }

      return this.subscribeTrackToStreamMap.get(trackId);
    }
  }, {
    key: "streamIdForSSRC",
    value: function streamIdForSSRC(ssrcId) {
      if (!this.subscribeSsrcToStreamMap) {
        return undefined;
      }

      return this.subscribeSsrcToStreamMap.get(ssrcId);
    }
  }, {
    key: "overrideStreamIdMappings",
    value: function overrideStreamIdMappings(previous, current) {
      if (this.subscribeTrackToStreamMap) {
        var _iterator11 = _createForOfIteratorHelper(this.subscribeTrackToStreamMap.entries()),
            _step11;

        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var _ref3 = _step11.value;

            var _ref2 = _slicedToArray(_ref3, 2);

            var track = _ref2[0];
            var streamId = _ref2[1];

            if (previous === streamId) {
              this.subscribeTrackToStreamMap.set(track, current);
              break;
            }
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
      }

      if (this.subscribeSsrcToStreamMap) {
        var _iterator12 = _createForOfIteratorHelper(this.subscribeSsrcToStreamMap.entries()),
            _step12;

        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var _ref6 = _step12.value;

            var _ref5 = _slicedToArray(_ref6, 2);

            var ssrc = _ref5[0];
            var _streamId = _ref5[1];

            if (previous === _streamId) {
              this.subscribeSsrcToStreamMap.set(ssrc, current);
              break;
            }
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
      }
    }
  }, {
    key: "streamsPausedAtSource",
    value: function streamsPausedAtSource() {
      var paused = new DefaultVideoStreamIdSet_1.default();

      if (this.currentIndex) {
        var _iterator13 = _createForOfIteratorHelper(this.currentIndex.pausedAtSourceIds),
            _step13;

        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var streamId = _step13.value;
            paused.add(streamId);
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
      }

      return paused;
    }
  }, {
    key: "buildTrackToStreamMap",
    value: function buildTrackToStreamMap(subscribeAck) {
      var map = new Map();
      this.logger.debug(function () {
        return "trackMap ".concat(JSON.stringify(subscribeAck.tracks));
      });

      var _iterator14 = _createForOfIteratorHelper(subscribeAck.tracks),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var trackMapping = _step14.value;

          if (trackMapping.trackLabel.length > 0 && trackMapping.streamId > 0) {
            map.set(trackMapping.trackLabel, trackMapping.streamId);
          }
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }

      return map;
    }
  }, {
    key: "buildSSRCToStreamMap",
    value: function buildSSRCToStreamMap(subscribeAck) {
      var map = new Map();
      this.logger.debug(function () {
        return "ssrcMap ".concat(JSON.stringify(subscribeAck.tracks));
      });

      var _iterator15 = _createForOfIteratorHelper(subscribeAck.tracks),
          _step15;

      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var trackMapping = _step15.value;

          if (trackMapping.trackLabel.length > 0 && trackMapping.streamId > 0) {
            map.set(trackMapping.ssrc, trackMapping.streamId);
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }

      return map;
    }
  }, {
    key: "buildStreamToAttendeeMap",
    value: function buildStreamToAttendeeMap(indexFrame) {
      var map = new Map();

      if (indexFrame) {
        var _iterator16 = _createForOfIteratorHelper(indexFrame.sources),
            _step16;

        try {
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            var source = _step16.value;
            map.set(source.streamId, source.attendeeId);
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }
      }

      return map;
    }
  }, {
    key: "buildStreamExternalUserIdMap",
    value: function buildStreamExternalUserIdMap(indexFrame) {
      var map = new Map();

      if (indexFrame) {
        var _iterator17 = _createForOfIteratorHelper(indexFrame.sources),
            _step17;

        try {
          for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
            var source = _step17.value;

            if (!!source.externalUserId) {
              map.set(source.streamId, source.externalUserId);
            }
          }
        } catch (err) {
          _iterator17.e(err);
        } finally {
          _iterator17.f();
        }
      }

      return map;
    }
  }, {
    key: "trySelectHighBitrateForAttendees",
    value: function trySelectHighBitrateForAttendees(attendeeToStreamDescriptorMap, highAttendees, currentUsage, bandwidthKbps, currentSelectionRef) {
      var _iterator18 = _createForOfIteratorHelper(highAttendees),
          _step18;

      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var attendeeId = _step18.value;

          if (currentUsage >= bandwidthKbps) {
            break;
          }

          if (attendeeToStreamDescriptorMap.has(attendeeId)) {
            var streams = attendeeToStreamDescriptorMap.get(attendeeId);

            var _iterator19 = _createForOfIteratorHelper(streams.reverse()),
                _step19;

            try {
              for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                var l = _step19.value;

                if (currentUsage - currentSelectionRef.get(attendeeId).maxBitrateKbps + l.maxBitrateKbps < bandwidthKbps) {
                  currentUsage = currentUsage - currentSelectionRef.get(attendeeId).maxBitrateKbps + l.maxBitrateKbps;
                  currentSelectionRef.set(attendeeId, l);
                  break;
                }
              }
            } catch (err) {
              _iterator19.e(err);
            } finally {
              _iterator19.f();
            }
          }
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }

      return currentUsage;
    }
  }, {
    key: "buildAttendeeToSortedStreamDescriptorMapExcludingSelf",
    value: function buildAttendeeToSortedStreamDescriptorMapExcludingSelf(selfAttendeeId) {
      var attendeeToStreamDescriptorMap = new Map();

      if (this.currentIndex) {
        var _iterator20 = _createForOfIteratorHelper(this.currentIndex.sources),
            _step20;

        try {
          for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
            var source = _step20.value;

            if (source.attendeeId === selfAttendeeId || source.mediaType !== SignalingProtocol_js_1.SdkStreamMediaType.VIDEO) {
              continue;
            }

            if (attendeeToStreamDescriptorMap.has(source.attendeeId)) {
              attendeeToStreamDescriptorMap.get(source.attendeeId).push(source);
            } else {
              attendeeToStreamDescriptorMap.set(source.attendeeId, [source]);
            }
          }
        } catch (err) {
          _iterator20.e(err);
        } finally {
          _iterator20.f();
        }
      }

      attendeeToStreamDescriptorMap.forEach(function (streams, _attendeeId) {
        streams.sort(function (stream1, stream2) {
          if (stream1.maxBitrateKbps > stream2.maxBitrateKbps) {
            return 1;
          } else if (stream1.maxBitrateKbps < stream2.maxBitrateKbps) {
            return -1;
          } else {
            return 0;
          }
        });
      });
      return attendeeToStreamDescriptorMap;
    }
  }]);

  return DefaultVideoStreamIndex;
}();

exports.default = DefaultVideoStreamIndex;